export default function playVideos(flkty) {
    const cells = flkty.cells;
    const selectedIndex = flkty.selectedIndex;
    const currentNode = cells[selectedIndex].element;
    const currentVideo = currentNode.querySelector('video');
    if (!currentVideo.querySelector('source')) {
        const sourceWebm = document.createElement('source');
        const sourceMp4 = document.createElement('source');
        sourceWebm.setAttribute('type', 'video/webm');
        sourceMp4.setAttribute('type', 'video/MP4');
        sourceWebm.setAttribute('src', `${currentNode.getAttribute('data-src')}.webm`);
        sourceMp4.setAttribute('src', `${currentNode.getAttribute('data-src')}.mp4`);
        currentVideo.appendChild(sourceWebm);
        currentVideo.appendChild(sourceMp4);
    }
    currentVideo.currentTime = 0;
    currentVideo.play();

    const otherCells = cells.filter(cell => cell !== cells[selectedIndex]);

    otherCells.forEach((cell) => {
        const videoElem = cell.element.querySelector('video');
        //
        // const sources = videoElem.querySelectorAll('source');
        // if (sources) {
        //     sources.forEach((source) => {
        //         videoElem.removeChild(source);
        //     })
        // }
        if (!videoElem.paused) {
            setTimeout(() => {
                videoElem.pause();
            }, 2000);
        }
    });
}



// WEBPACK FOOTER //
// ./src/js/services/helpers.js